import { render, staticRenderFns } from "./OnlineWaTemplatePickerModal.vue?vue&type=template&id=d604c0b0&scoped=true&"
import script from "./OnlineWaTemplatePickerModal.vue?vue&type=script&lang=js&"
export * from "./OnlineWaTemplatePickerModal.vue?vue&type=script&lang=js&"
import style0 from "./OnlineWaTemplatePickerModal.vue?vue&type=style&index=0&id=d604c0b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d604c0b0",
  null
  
)

export default component.exports